import React, { useState, useEffect } from 'react';
import { useHRMS } from '../context/HRMSContext.jsx';
import api from '../services/api.js';
import DatePicker from '../components/DatePicker.jsx';
import Message from '../components/Message.jsx';

function Attendance() {
  const { state, loadAttendance } = useHRMS();

  // Get today's date in local timezone (YYYY-MM-DD format)
  const getTodayDate = () => {
    const today = new Date();
    // Use local timezone, not UTC
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;

  };


  const todayDate = getTodayDate();

  const [selectedDate, setSelectedDate] = useState(todayDate);
  const [showMarkForm, setShowMarkForm] = useState(false);
  const [attendanceData, setAttendanceData] = useState({
    workerId: '', date: todayDate, checkIn: '', checkOut: '', otCheckIn: '', otCheckOut: '', status: 0
  });
  const [message, setMessage] = useState({ text: '', type: '' });


  // Load attendance data when component mounts
  useEffect(() => {
    loadAttendance();
  }, [loadAttendance]);

  const handleMarkAttendance = async (e) => {
    e.preventDefault();

    // Check if attendance already exists for this worker on this date
    const existingAttendance = state.attendance?.find(att => {
      const attDate = att.date?.split('T')[0] || att.date; // Handle both date formats
      return att.workerId === attendanceData.workerId && attDate === attendanceData.date;
    });

    if (existingAttendance) {
      setMessage({ text: `Attendance already exists for this worker on ${attendanceData.date}!`, type: 'error' });
      return;
    }

    //   if (attendanceData.checkIn && attendanceData.checkOut) {
    //   const inTime = attendanceData.checkIn;
    //   const outTime = attendanceData.checkOut;

    //   // If Check-In is greater than or equal to Check-Out
    //   if (inTime >= outTime) {
    //     alert("❌ Check-In time cannot be greater than or equal to Check-Out time!");
    //     return; // STOP form submit

    //   }
    // }

    try {
      // Create payload with selected date
      const payload = {
        workerId: attendanceData.workerId,
        date: attendanceData.date,
        checkIn: attendanceData.checkIn,
        checkOut: attendanceData.checkOut,
        otCheckIn: attendanceData.otCheckIn || null,
        otCheckOut: attendanceData.otCheckOut || null,
        status: attendanceData.status
      };

      // Use date from form data
      const savedAttendance = await api.attendance.create(payload);
      // Update selectedDate to show the newly added attendance
      setSelectedDate(attendanceData.date);

      setMessage({ text: `Attendance marked successfully for ${attendanceData.date}!`, type: 'success' });

      // Reload attendance data to get the latest attendance
      await loadAttendance();

      // Reset form with today's date for next entry
      const newTodayDate = getTodayDate();
      setAttendanceData({ workerId: '', date: newTodayDate, checkIn: '', checkOut: '', otCheckIn: '', otCheckOut: '', status: 0 });
      setShowMarkForm(false);


    } catch (error) {
      console.error('❌ Error marking attendance:', error);
      setMessage({ text: `Error marking attendance: ${error.message || 'Unknown error'}`, type: 'error' });
    }
  };

  const getAttendanceForDate = () => {
    if (!Array.isArray(state.attendance)) {
      console.warn('⚠️ state.attendance is not an array:', state.attendance);
      return [];
    }

    // Format date for comparison (handle both date formats)
    const formatDate = (dateStr) => {
      if (!dateStr) return '';

      // If already in YYYY-MM-DD format, return as is
      if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return dateStr;
      }

      // If date is in format "YYYY-MM-DDTHH:mm:ss.sssZ" or Date object
      try {
        const date = new Date(dateStr);
        // Check if date is valid
        if (isNaN(date.getTime())) {
          console.warn('⚠️ Invalid date:', dateStr);
          return '';
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const formatted = `${year}-${month}-${day}`;
        return formatted;
      } catch (e) {
        console.error('❌ Error formatting date:', dateStr, e);
        return '';
      }
    };

    const filtered = state.attendance.filter(att => {
      const attDate = formatDate(att.date);
      const match = attDate === selectedDate;
      return match;
    });

    return filtered;
  };

  const getWorkerName = (attendance) => {
    // First try to get name from attendance object (from backend)
    if (attendance.workerName) {
      return attendance.workerName;
    }
    // Fallback to finding worker by ID
    const worker = state.workers?.find(w => w.id === attendance.workerId);
    return worker ? worker.name : 'Unknown';
  };

  return (
    <div className="attendance">
      {message.text && (
        <Message 
          message={message.text} 
          type={message.type} 
          onClose={() => setMessage({ text: '', type: '' })} 
        />
      )}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Attendance Management</h2>
        <button className="btn btn-primary" onClick={() => {
          const today = getTodayDate();
          setAttendanceData({ workerId: '', date: today, checkIn: '', checkOut: '', otCheckIn: '', otCheckOut: '', status: 0 });
          setShowMarkForm(true);

        }}>
          Mark Attendance
        </button>
      </div>

      <div className="row mb-4">
        <div className="col-md-4">
          <label className="form-label">Select Date to View</label>
          <DatePicker
            value={selectedDate}
            onChange={setSelectedDate}
            placeholder="Select date to view attendance"
          />
          <small className="text-muted d-block mt-1">Showing attendance for: <strong>{selectedDate}</strong></small>
        </div>
      </div>

      {showMarkForm && (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Mark Attendance</h5>
                <button type="button" className="btn-close" onClick={() => {
                  setShowMarkForm(false);
                  setAttendanceData({ workerId: '', date: getTodayDate(), checkIn: '', checkOut: '', otCheckIn: '', otCheckOut: '', status: 0 });
                }}></button>
              </div>
              <form onSubmit={handleMarkAttendance}>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Date *</label>
                      <DatePicker
                        value={attendanceData.date}
                        onChange={(date) => setAttendanceData({ ...attendanceData, date })}
                        placeholder="Select attendance date"
                        maxDate={getTodayDate()}   // ⛔ Prevent future dates
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Worker *</label>
                      <select
                        className="form-control"
                        value={attendanceData.workerId}
                        onChange={(e) => setAttendanceData({ ...attendanceData, workerId: parseInt(e.target.value) })}
                        required
                      >
                        <option value="">Select Worker</option>
                        {Array.isArray(state.workers) && state.workers.map(worker => (
                          <option key={worker.id} value={worker.id}>{worker.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        value={attendanceData.status}
                        onChange={(e) => setAttendanceData({ ...attendanceData, status: parseInt(e.target.value) })}
                        required  >
                        <option value={0}>Present</option>


                      </select>
                    </div>  
                    <div className="col-md-4">
                      <label className="form-label">Check In</label>
                      <input
                        type="time"
                        className="form-control"
                        value={attendanceData.checkIn}
                        onChange={(e) => setAttendanceData({ ...attendanceData, checkIn: e.target.value })}
                        required />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Check Out</label>
                      <input
                        type="time"
                        className="form-control"
                        value={attendanceData.checkOut}
                        onChange={(e) => setAttendanceData({ ...attendanceData, checkOut: e.target.value })}
                        required />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">OT Check In</label>
                      <input
                        type="time"
                        className="form-control"
                        value={attendanceData.otCheckIn}
                        onChange={(e) => setAttendanceData({ ...attendanceData, otCheckIn: e.target.value })}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">OT Check Out</label>
                      <input
                        type="time"
                        className="form-control"
                        value={attendanceData.otCheckOut}
                        onChange={(e) => setAttendanceData({ ...attendanceData, otCheckOut: e.target.value })}
                      />
                    </div>
                    
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-success">Save</button>
                  <button type="button" className="btn btn-secondary" onClick={() => {
                    setShowMarkForm(false);
                    setAttendanceData({ workerId: '', date: getTodayDate(), checkIn: '', checkOut: '', otCheckIn: '', otCheckOut: '', status: 0 });
                  }}>Close</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>Attendance for {selectedDate}</h5>
          <button className="btn btn-sm btn-outline-secondary" onClick={loadAttendance} title="Refresh">
            🔄 Refresh
          </button>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Worker</th>
                  <th>Check In</th>
                  <th>Check Out</th>
                  <th>OT In</th>
                  <th>OT Out</th>
                  <th>Status</th>
                  <th>Working Hours</th>
                  <th>OT Hours</th>
                </tr>
              </thead>
              <tbody>
                {getAttendanceForDate().length > 0 ? (
                  getAttendanceForDate().map(attendance => {
                    // Calculate working hours from time strings
                    const calculateWorkingHours = (checkIn, checkOut) => {
                      if (!checkIn || !checkOut) return '0';

                      const [inHours, inMinutes] = checkIn.split(':').map(Number);
                      const [outHours, outMinutes] = checkOut.split(':').map(Number);

                      const inTotal = inHours * 60 + inMinutes;
                      let outTotal = outHours * 60 + outMinutes;

                      if (outTotal < inTotal) {
                        outTotal += 24 * 60;
                      }

                      const diffMinutes = outTotal - inTotal;
                      return (diffMinutes / 60).toFixed(1);
                    };

                    const calculateOTHours = (otCheckIn, otCheckOut) => {
                      if (!otCheckIn || !otCheckOut) return '0';

                      const [inHours, inMinutes] = otCheckIn.split(':').map(Number);
                      const [outHours, outMinutes] = otCheckOut.split(':').map(Number);

                      const inTotal = inHours * 60 + inMinutes;
                      let outTotal = outHours * 60 + outMinutes;

                      if (outTotal < inTotal) {
                        outTotal += 24 * 60;
                      }

                      const diffMinutes = outTotal - inTotal;
                      return (diffMinutes / 60).toFixed(1);
                    };

                    const workingHours = calculateWorkingHours(attendance.checkIn, attendance.checkOut);
                    const otHours = calculateOTHours(attendance.otCheckIn, attendance.otCheckOut);

                    const statusText = 'Present';

                    return (
                      <tr key={attendance.id}>
                        <td>{getWorkerName(attendance)}</td>
                        <td>{attendance.checkIn || '-'}</td>
                        <td>{attendance.checkOut || '-'}</td>
                        <td>{attendance.otCheckIn || '-'}</td>
                        <td>{attendance.otCheckOut || '-'}</td>
                        <td>
                          <span className="badge bg-success">
                            {statusText}
                          </span>
                        </td>
                        <td>{workingHours} hrs</td>
                        <td>{otHours} hrs</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center text-muted">
                      No attendance records found for {selectedDate}
                      <br />
                      <small>Total attendance records: {Array.isArray(state.attendance) ? state.attendance.length : 0}</small>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Attendance;